<form [formGroup]="formGroup" novalidate>
  <ng-container formArrayName="reisen">
    <ng-container *ngFor="let reiseGroup of reisenFormArray.controls; let i=index" [formGroupName]="i">
        <ng-container formArrayName="buchungen">
          <ng-container *ngFor="let buchungGroup of reiseGroup.controls['buchungen'].controls; let j=index"
               [formGroupName]="j">
            <mat-card>
              <mat-card-header>
                <mat-checkbox matInput formControlName="selected" color="primary">
                  {{reiseGroup.controls['reiseLabel'].value}} - {{buchungGroup.controls['teilnehmer'].value.name()}}
                  <ng-container *ngIf="buchungGroup.controls['eb'].value.bereitsGebucht">
                    (bereits gebucht)
                  </ng-container>
                </mat-checkbox>
              </mat-card-header>
              <mat-card-content *ngIf="buchungGroup.controls['selected'].value">
                  <!-- formControlName="kategorie" instead of [formControl] triggers following error:
                       There is no FormControl instance attached to form control element with path: 'reisen -> 0 -> einzelBuchungen -> 0 -> zustieg'
                       see https://github.com/angular/material2/issues/5720
                  -->
                  <mat-form-field *ngIf="buchungGroup.contains('zustieg')">
                    <mat-select [formControl]="buchungGroup.controls['zustieg']" placeholder="Zustieg" required>
                      <mat-option *ngFor="let item of reiseGroup.controls['reise'].value.zustiege" [value]="item">{{item.zeit}} {{item.ort}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="buchungGroup.contains('kategorie')">
                    <mat-select [formControl]="buchungGroup.controls['kategorie']" placeholder="Kategorie" required>
                      <mat-option *ngFor="let item of reiseGroup.controls['reise'].value.kategorienFilteredByAlter(buchungGroup.controls['teilnehmer'].value.geburtsdatum)"
                                  [value]="item">{{item | namePreis}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="buchungGroup.contains('kurs')">
                    <mat-select [formControl]="buchungGroup.controls['kurs']" placeholder="Guiding">
                      <mat-option matInput *ngFor="let item of reiseGroup.controls['reise'].value.kurse" [value]="item">{{item | namePreis}}</mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field *ngIf="buchungGroup.contains('zimmerwunsch')">
                    <input matInput formControlName="zimmerwunsch" placeholder="Zimmerwunsch mit">
                    <mat-hint align="start">Name oder Gruppe</mat-hint>
                  </mat-form-field>

                  <ng-container *ngIf="buchungGroup.contains('kurtaxeCheckbox')">
                      <mat-checkbox matInput formControlName="kurtaxeCheckbox" color="primary" style="padding-left: 1em;">
                          <span nowrap>Kurtaxe (Pflichtabgabe {{reiseGroup.controls['reise'].value.kurtaxe | preis}}): bequem per Vorkasse (alternativ selbstständig im Hotel)</span>
                      </mat-checkbox>
                  </ng-container>

                  <ng-container *ngIf="buchungGroup.contains('sorgenfreiTarifCheckbox')">
                      <mat-checkbox matInput formControlName="sorgenfreiTarifCheckbox" color="primary" style="padding-left: 1em;">
                          <span nowrap>Sorgenfrei-Tarif ({{reiseGroup.controls['reise'].value.sorgenfreiTarif | preis}}): Übernahme der Stornokosten bei belegbarer Erkrankung.</span>
                          <br>
                          Die Mindestbuchungsgebühr 10€ fällt an. Bei Buchung abschließen.
                      </mat-checkbox>
                  </ng-container>
              </mat-card-content>
            </mat-card>
            <br>
          </ng-container>
        </ng-container>

    </ng-container>
  </ng-container>
  <div [hidden]="!kursSelected" class="alert alert-info">
    {{service.texte.hinweiseGuiding()}}
  </div>
</form>
